import React, { useEffect, useRef } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { selectIsUserAuthenticated } from 'features/auth/selectors'

import './TopBannerHoc.scss'

const b = block('top-banner-hoc')

interface ITopBannerHoc {
  isShowNotification: boolean
  needAuth?: boolean
  allPromotionsIsExpired: boolean
  onCloseBanner: () => void
}

const TopBannerHoc: React.FC<ITopBannerHoc> = props => {
  const { children, isShowNotification, needAuth = false, allPromotionsIsExpired, onCloseBanner } = props
  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const checkAuth = needAuth ? isAuth : !needAuth
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!checkAuth) {
      onCloseBanner()
    }

    const el = containerRef.current

    const updateHeight = () => {
      if (!el || !checkAuth || !isShowNotification || allPromotionsIsExpired) {
        document.body.style.setProperty('--banner-height', '0px')
        return
      }

      const height = el.offsetHeight
      document.body.style.setProperty('--banner-height', `${height}px`)
    }

    updateHeight()

    // Track dynamic content/viewport changes
    let resizeObserver: ResizeObserver | undefined
    if (typeof ResizeObserver !== 'undefined' && el) {
      resizeObserver = new ResizeObserver(() => updateHeight())
      resizeObserver.observe(el)
    }

    return () => {
      if (resizeObserver && el) {
        resizeObserver.unobserve(el)
      }
      document.body.style.setProperty('--banner-height', '0px')
    }
  }, [isShowNotification, isAuth, allPromotionsIsExpired, checkAuth, onCloseBanner])

  return (
    <>
      {isShowNotification && !allPromotionsIsExpired ? (
        <div className={b()} ref={containerRef}>
          <div className={b('wrapper')}>
            {children}
            <div className={b('close-block')} onClick={onCloseBanner}>
              <span className={b('close-icon')}>×</span>
            </div>
          </div>
        </div>
      ) : null}
    </>
  )
}

export default TopBannerHoc
